import store from '@/store';
import { DVB_TYPE, SERVICE_TYPE, TV_STATUS } from '.';
import RPIController from '../RPIController';

export default class RPI {
  static get socket() {
    return window.rpi;
  }

  static setChannel(channel, type = SERVICE_TYPE.TV) {
    if (!this.socket) {
      console.log('Missing WEBAPIS.AVPLAY');
      return;
    }

    if (type === SERVICE_TYPE.TV) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.INFO) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.RADIO) this.handleRadioChannel(channel);
  }

  static removePlayer() {
    this.clearChannel();
  }

  static handleTVChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        const modChannel = {
          ...channel,
          url: channel.url.replace('igmp://', 'udp://@'),
        };
        this.setIPTVChannel(modChannel);
        break;
      case DVB_TYPE.C:
      case DVB_TYPE.S:
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static handleRadioChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        const modChannel = {
          ...channel,
          url: channel.url.replace('igmp://', 'udp://@'),
        };
        this.setIPTVChannel(modChannel);
        break;
      case DVB_TYPE.C:
      case DVB_TYPE.S:
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static async setIPTVChannel(channel) {
    this.clearChannel();

    await this.createPlayer(channel);
    return Promise.resolve();
  }

  static createPlayer(channel) {
    try {
      console.log('URL: ', channel.url);
      store.dispatch('notification/new', {
        title: 'Call Channel',
        message: channel.url,
      });
      RPIController.emit('tvplayer/sendMessage', {
        message: `{"command": ["loadfile", "http://192.168.178.29:8080/${channel.url}", "replace"]}`,
      });
      store.dispatch('tv/setStatus', TV_STATUS.LOADED);
    } catch (e) {
      console.log('ERROR while selecting channel: ', e);
    }
    return Promise.resolve();
  }

  static clearChannel() {
    // RPIController.emit('tvplayer/kill');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/RADIO/RPI.js